module.exports = __webpack_public_path__ + "static/media/four.2a74b0e0.jpg";